export default "__VITE_ASSET__Cp7p3ADt__"